import http from '../config'
const drug = {
  products({ id, params }) {
    return http({
      url: `drug/products/${id}`,
      params
    })
  },
  preSettleOrder(data) {
    return http({
      url: 'drug/bbc/preSettleOrder',
      method: 'post',
      data
    })
  },
  orders(data) {
    return http({
      url: 'drug/bbc/orders',
      method: 'post',
      data
    })
  },
  preSettleShoppingCart(data) {
    return http({
      url: 'drug/bbc/preSettleShoppingCart',
      method: 'post',
      data
    })
  },
  carts(params) {
    return http({
      url: 'shopping_cart/server/details',
      params
    })
  },
  shoppingCartOrders(data) {
    return http({
      url: 'drug/bbc/shoppingCartOrders',
      method: 'post',
      data
    })
  }
}
export default drug
